import React from 'react';
import { Select, Form } from 'antd';
import filterConnect from '../../../../../../../common/hoc/filterConnect';
const Option = Select.Option;

// todo onChange={onChangePaymentMethodsOrder}  value={filter.settlementForm}
const PaymentMethods = ({ form, paymentMethods }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Форма расчета:">
      {getFieldDecorator('regions')(
        <Select
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите форму расчета"
          allowClear={true}
          mode="multiple"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {paymentMethods &&
            paymentMethods.map(method => (
              <Option key={method.paymentMethodId}>
                {method.paymentMethod}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default filterConnect(PaymentMethods, ['paymentMethods']);
